import React from "react";
// types
import { TMainPageLayoutV2 } from "../type";


const MNPG010 = ( props:TMainPageLayoutV2 ) => {
    console.log("MNPG010.rendered: ", props);
    return null;
}

const Component = React.memo(MNPG010, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG010.memo", { prevProps, nextProps });
    return true;
});

export default Component;
